import { WeatherServiceParams } from '../../types/weather';

export async function fetchDroughtData(_: any[], params: WeatherServiceParams) {
  try {
    if (!params.selectedState) {
      throw new Error('Please select a state to view drought data');
    }

    const response = await fetch('https://api-dev.catxre.com/weather/drought-data', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        states: [params.selectedState]
      })
    });

    if (!response.ok) {
      throw new Error(`Drought API error: ${response.statusText}`);
    }

    const data = await response.json();
    if (!data) {
      throw new Error('No drought data returned');
    }

    return data;
  } catch (error) {
    console.error('Drought API error:', error);
    throw error;
  }
}